import React, { useEffect, useState } from 'react';
import '../../styles/Admin/accountForms.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { GrUserAdmin } from 'react-icons/gr';
import Toast from 'awesome-toast-component';
import { displaySnackbar } from "../../utilities";
import { BASE_URL } from "../../settings";

export default function Admin_AddAnnoucement({ fetchAnnouncements }) {
    const [title, setTitle] = useState('');
    const [priority, setPriority] = useState('');
    const [details, setDetails] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // 👇️ handler for creating a new announcement.
    const createAnnouncement = () => {
        setError(null);
        setMessage(null);
        setShowLoading(true);

        if (title && title?.length > 0 && isNaN(title) && title?.trim()) {
            if (
                priority &&
                priority?.length > 0 &&
                isNaN() &&
                priority?.trim() &&
                (priority?.toLowerCase() === 'high' || priority?.toLowerCase() === 'low')
            ) {
                if (details && details?.length > 0 && isNaN(details) && details?.trim()) {
                    fetch(`${BASE_URL}/announcements`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            title,
                            priority,
                            details,
                        }),
                    })
                        .then(async (result) => {
                            setShowLoading(false);
                            setError(null);
                            let response = await result?.json();
                            if (response?.msg === null) {
                                setError(response?.errorMsg);
                                displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                            } else {
                                console.log(response);
                                setMessage(response?.msg);
                                displaySnackbar(response?.msg, false, 'Ok', () => {});
                                setTimeout(() => {
                                    fetchAnnouncements();
                                    navigate('/admin.console/announcements');
                                }, 1000);
                            }
                        })
                        .catch((error) => {
                            if (error?.message == 'Failed to fetch') {
                                setError('Could not reach the servers');
                                displaySnackbar(
                                    'Could not reach the servers',
                                    true,
                                    'Ok',
                                    () => {}
                                );
                            } else {
                                setError('Some error occurred!');
                                displaySnackbar('Some error occured!', true, 'Ok', () => {});
                                console.log('the error:', error);
                            }
                            setShowLoading(false);
                            setMessage(null);
                        });
                } else {
                    setShowLoading(false);
                    setError('Provide details!');
                    setMessage(null);
                }
            } else {
                setShowLoading(false);
                setError('Provide priority!');
                setMessage(null);
            }
        } else {
            setShowLoading(false);
            setError('Provide title!');
            setMessage(null);
        }
    };

    return (
        <div className='admin-login-container'>
            <div className='login-container'>
                <div className='form-header-container'>
                    <span
                        style={{
                            fontSize: '2rem',
                        }}
                    >
                        📢
                    </span>
                    <h1 className='form-header'>New Announcement</h1>
                </div>

                {error && <span className='error'>{error}</span>}
                {message && <span className='message'>{message}</span>}

                <div className='form-inputs'>
                    <input
                        type='text'
                        name='title'
                        placeholder='Title'
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    <select name='priority' onChange={(e) => setPriority(e?.target?.value)}>
                        <option selected disabled>
                            Priority
                        </option>
                        <option value={'high'}>high</option>
                        <option value={'low'}>low</option>
                    </select>
                    <textarea
                        type='text'
                        name='details'
                        placeholder='Details'
                        rows={10}
                        value={details}
                        onChange={(e) => setDetails(e.target.value)}
                    />
                </div>

                <button
                    className='action-btn'
                    onClick={createAnnouncement}
                    disabled={
                        showLoading ||
                        title?.length <= 0 ||
                        priority?.length <= 0 ||
                        details?.length <= 0
                    }
                    style={{
                        backgroundColor:
                            showLoading || !title || !priority || !details ? '#aaa' : 'darkblue',
                        color: showLoading || !title || !priority || !details ? '#333' : '#eee',
                    }}
                >
                    Create
                </button>

                <span className='link' onClick={() => navigate('/admin.console/announcements')}>
                    👈️ Go back to announcements
                </span>
            </div>
        </div>
    );
}
